import { Component } from '@angular/core';

@Component({
  selector: 'asset-card-skeleton',
  templateUrl: './asset-card-skeleton.html',
  styleUrl: './asset-card-skeleton.scss',
})
export class AssetCardSkeleton {}
